// import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';

// a singleton history object
const history = createBrowserHistory();
export default history;
